import axios from 'axios';
import { generateUrl, getTenantId } from '../helpers';
const detectFaces = axios.create({
    baseURL: generateUrl('interview_backend_url'),
});

detectFaces.interceptors.request.use(
    function (config) {
        let token = localStorage.getItem('token');
        if (token && token !== null) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        const tenantId = getTenantId();
        if (tenantId && tenantId !== 'undefined' && tenantId !== 'null') {
            config.headers['x-tenant-id'] = tenantId;
        } else {
            delete config.headers['x-tenant-id']; // ensure it’s not passed at all
        }
        return config;
    },
    function (error) {
        return Promise.reject(error);
    }
);

detectFaces.interceptors.response.use(
    (response) => {
        return response;
    },
    function (error) {
        return Promise.reject(error);
    }
);

export default detectFaces;
